import {
    Grid,
    TextField,
    Typography
} from "@material-ui/core"
import React from "react"

const ProviderRegisterPassword = (props) => {

    const changeValue = (event) => {
        props.updateProvider({ ...props.provider, [event.target.name]: event.target.value })
    }

    return (
        <div>
            <Grid container direction="row"
                justifyContent="center"
                spacing={2}
                alignItems="center"
            >
                <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="subtitle2" gutterBottom>
                        Senha de Acesso
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={6} md={6}>
                    <TextField
                        label="Senha"
                        margin="normal"
                        id="password"
                        name="password"
                        variant="outlined"
                        type="password"
                        onChange={changeValue}
                        helperText={props.required.password ? "As senhas precisam ser iguais" : ""}
                        error={props.required.password}
                        value={props.provider.password}
                        fullWidth />
                </Grid>
                <Grid item xs={12} lg={6} md={6}>
                    <TextField
                        label="Confirme a Senha"
                        margin="normal"
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        variant="outlined"
                        helperText={props.required.password ? "As senhas precisam ser iguais" : ""}
                        onChange={changeValue}
                        error={props.required.password}
                        value={props.provider.confirmePassword}
                        fullWidth />
                </Grid>
            </Grid>
        </div>
    )
}

export default ProviderRegisterPassword